import React from 'react';
import { OmniAppHeaderContainer, OmniAppHeaderSection } from '../ui/appheader';
import AppBrand from './AppBrand';
import AppNavigation from './AppNavigation';
import CountrySelector from './CountryAgencySelector';
import AppControls from './AppControls';
import { IUpdatedQuery } from '../../context/queryBuilderProvider';
import { IJsonQuery } from '../HistoryDrawer';

// Country types
interface CountryAgency {
  value: string;
  label?: string;
}

// Props interface for AppHeader component
interface AppHeaderProps {
  // User and auth related props
  displayUserName: string | null;
  userName: string;
  isLoggedIn: boolean;
  signIn: () => void;
  signOut: () => void;

  // Country selection props (agency removed)
  countries: CountryAgency[];
  selectedCountry: CountryAgency | null;
  selectCountry: (value: string) => void;

  // Theme and UI props
  toggleColorMode: () => void;
  colorModeIcon: { color: string };

  // Update function for HistoryDrawer
  updateFunction: (query: IUpdatedQuery | IJsonQuery) => string;
}

const AppHeader: React.FC<AppHeaderProps> = ({
  displayUserName,
  userName,
  isLoggedIn,
  signIn,
  signOut,
  countries,
  selectedCountry,
  selectCountry,
  toggleColorMode,
  colorModeIcon,
  updateFunction,
}) => {
  return (
    <OmniAppHeaderContainer
      justify="space-between"
      align="center"
      gap={[0, 1, 1, 1, 1]}
      fontSize={['xs', 'sm', 'md', 'lg', 'xl']}
      p={[1, 2, 3, 4, 5]}
      maxHeight="70px"
    >
      {/* Left side - Brand and Navigation */}
      <OmniAppHeaderSection align="center" gap={[1, 2]} position="left">
        <AppBrand />
        <AppNavigation
          displayUserName={displayUserName}
          userName={userName}
          updateFunction={updateFunction}
        />
      </OmniAppHeaderSection>

      {/* Right side - Selectors and Controls */}
      <OmniAppHeaderSection
        justify="flex-end"
        align="center"
        gap={[1, 2]}
        position="right"
      >
        <CountrySelector
          countries={countries}
          selectedCountry={selectedCountry}
          selectCountry={selectCountry}
        />
        <AppControls
          isLoggedIn={isLoggedIn}
          signIn={signIn}
          signOut={signOut}
          toggleColorMode={toggleColorMode}
          colorModeIcon={colorModeIcon}
        />
      </OmniAppHeaderSection>
    </OmniAppHeaderContainer>
  );
};

export default AppHeader;
